import { booleanDisplayString } from '@/utils/booleanDisplay';

/**
 * Flatten an audio-file-issue `details` bag into label/value rows for the inspector
 * detail list. Primitives in the bag render as-is (booleans as "Yes" / "No"); nested
 * objects / arrays fall back to compact JSON.
 *
 * `details` is a backend JSON column. Its declared shape is an object, but a defensive
 * guard matters: `Object.entries` on a bare string would enumerate it per character
 * (`'0' → 'a'`, `'1' → 'b'`, …) and on a number/boolean throws-or-empties, so any
 * non-object payload yields no rows instead of garbage. Arrays keep their index keys
 * (a valid, if rare, detail shape).
 */
export function issueDetailEntries(details: unknown): { key: string; value: string }[] {
  if (!details || typeof details !== 'object') {
    return [];
  }
  return Object.entries(details as Record<string, unknown>).map(([key, value]) => ({
    key,
    value:
      value === null || value === undefined
        ? '—'
        : typeof value === 'boolean'
          ? booleanDisplayString(value)
          : typeof value === 'object'
            ? JSON.stringify(value)
            : String(value),
  }));
}
